import React from 'react';

import Dialog from 'crehana-ui/Dialog';

import TrailerPlayer from 'Jsx/Shared/TrailerPlayer';

import ContentPreview from './components/ContentPreview';

const EVENTS = {
  COURSE_PREVIEW: {
    CLOSE: 'course_preview_close',
    OPEN: 'course_preview_open',
  },
};

type CoursePreviewProps = {
  onlyTrailer?: boolean;
  showButton?: boolean;
  showLevel?: boolean;
  dark?: boolean;
  temporalAccessDurationLabel?: string;
  hidePrices?: boolean;
};

const CoursePreview: React.FC<CoursePreviewProps> = ({
  onlyTrailer = false,
  showButton = true,
  showLevel = true,
  dark = false,
  hidePrices,
}) => {
  const initialState = {
    open: false,
    courseData: null,
    isPremium: false,
  };

  const [state, setState] = React.useState(initialState);

  const hideCoursePreview = () => {
    const { courseData } = state;

    if (courseData) {
      const user = courseData && courseData.user && courseData.user.originalId;

      setState({
        ...state,
        open: false,
      });

      window.track(EVENTS.COURSE_PREVIEW.CLOSE, {
        user,
      });
    }
  };

  const showCoursePreview = courseData => {
    setState({ ...state, open: true, courseData });
  };

  React.useEffect(() => {
    window.showCoursePreview = showCoursePreview;
  }, []);

  const { open, isPremium, courseData } = state

  return (
    <Dialog
      open={open}
      size="s"
      onDismiss={() => {
        hideCoursePreview();
      }}
      containerHTMLProps={{
        style: {
          width: 'auto',
          maxWidth: '100%',
          marginLeft: 0,
        },
      }}
      css={`
        width: auto !important;
        max-width: 568px !important;
        margin: 0 auto;
      `}
      hideCloseBtn
    >
      <div
        className={dark ? 'bg-base-main' : 'bg-white'}
        style={{ width: '90vw', maxWidth: 568, borderRadius: 5 }}
      >
        <React.Fragment>
          {courseData && (
            <TrailerPlayer
              courseId={courseData.originalId}
              title={courseData.title}
              promoVideoHashedId={courseData.promoVideoHashedId}
              promoImage={courseData.promoImage}
              imagePlaceholder={courseData.imagePlaceholder}
              trailerSource={courseData.trailerSource}
              autoplay
              withUserActivityTrack
            />
          )}
          {!onlyTrailer && (
            <ContentPreview
              {...courseData}
              isPremium={isPremium}
              showButton={showButton}
              showLevel={showLevel}
              dark={dark}
              hidePrices={hidePrices}
            />
          )}
        </React.Fragment>
      </div>
    </Dialog>
  );
};

export default CoursePreview;
